module.exports = __webpack_public_path__ + "static/media/map.6611b40c.avif";